/* eslint-disable max-len */
import React from 'react';
function ExternalTraining() {
    return (React.createElement("g", null,
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 4V19C2 20.1 2.9 21 4 21H15V19H4L4 4L22 4L24 4C24 2.9 23.1 2 22 2H4C2.9 2 2 2.9 2 4ZM22 7C22 8.11 21.11 9 20 9C18.89 9 18 8.11 18 7C18 5.89 18.89 5 20 5C21.11 5 22 5.89 22 7ZM10 15V17H8V15H6V13H8V11H10V13H12V15H10ZM18.5 10H12V12H16.5H18V17.5V23H22V17.5H23.5V12C23.5 10.9 22.6 10 21.5 10H20H18.5Z" })));
}
export default ExternalTraining;
